var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIdentity = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    fill: "none",
    className: "fill",
    viewBox: "10 7 20 30",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.147 36.59H11.353a1.2 1.2 0 0 1-1.2-1.2V10.034a1.2 1.2 0 0 1 1.2-1.2h18.794a1.2 1.2 0 0 1 1.2 1.2V35.39a1.2 1.2 0 0 1-1.2 1.2zm-17.594-2.4h16.394V11.234H12.553V34.19z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.6 7.218h-3.698v5.63H22.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.598 14.049h-3.697a1.2 1.2 0 0 1-1.2-1.2V7.217a1.2 1.2 0 0 1 1.2-1.2h3.697a1.2 1.2 0 0 1 1.2 1.2v5.63a1.2 1.2 0 0 1-1.2 1.2m-2.496-2.4h1.297V8.418h-1.297zM20.75 17.78a3 3 0 1 0-.001 6.002 3 3 0 0 0 .001-6.001m0 6.755c-2.004 0-6.004 1.006-6.004 3.002v1.576c0 .373.303.676.676.676h10.656a.676.676 0 0 0 .676-.676v-1.576c0-1.996-4-3.002-6.004-3.002"
  })));
};
export default SvgIdentity;